import React from 'react';
import { SearchInput, TextInput, TopToolbar } from 'react-admin';

/** Applications tab — venue ile aynı filtre satırı yüksekliği (3 alan). */
export const VENUE_APPLICATION_FILTERS = [
  <SearchInput source="name" key="venue-app-name" />,
  <SearchInput source="email" key="venue-app-email" />,
  <SearchInput source="phone" key="venue-app-phone" />,
];

/** Applications tab — organisation company ile aynı filtre satırı (2 alan). */
export const ORGANISATION_APPLICATION_FILTERS = [
  <SearchInput source="name" key="org-app-name" />,
  <SearchInput source="email" key="org-app-email" />,
];

/** Applications tab — sale agents (tek alwaysOn alan). */
export const SALE_AGENT_APPLICATION_FILTERS = [
  <TextInput
    source="name"
    alwaysOn
    key="sa-app-name"
    placeholder="Search Name"
    autoComplete="off"
  />,
];

/** @deprecated use SALE_AGENT_APPLICATION_FILTERS */
export const AFFILIATE_APPLICATION_FILTERS = SALE_AGENT_APPLICATION_FILTERS;

/** Toolbar yüksekliğini korur; içerik gizli (sekme geçişinde zıplama olmasın). */
export const TabbedListActionsPlaceholder = () => (
  <TopToolbar
    sx={{
      minHeight: 48,
      visibility: 'hidden',
      pointerEvents: 'none',
    }}
  >
    &nbsp;
  </TopToolbar>
);

export const TABBED_LIST_SX = {
  '& .RaListToolbar-root': {
    minHeight: 56,
    alignItems: 'center',
  },
  '& .RaList-actions': {
    minHeight: '48px !important',
  },
  '& .RaFilterForm-root': {
    minHeight: 56,
    boxSizing: 'border-box',
    alignItems: 'flex-end',
  },
  '& .RaFilterFormInput-spacer': {
    display: 'none',
  },
};
